import React from "react";
import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

const Leaderboard = ({ leaderboard, myPid }) => {
  const { t } = useTranslation();

  if (leaderboard.length === 0) {
    return (
      <Typography color="text.secondary" fontSize="0.9rem">
        {t("wb_no_participants")}
      </Typography>
    );
  }

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: "6px" }}>
      {leaderboard.map((row, index) => (
        <Box
          key={row.pid}
          sx={{
            display: "flex",
            alignItems: "center",
            gap: "8px",
            padding: "6px 10px",
            borderRadius: "10px",
            background: row.pid === myPid ? "rgba(0,145,247,0.12)" : "#F8F8FA",
            opacity: row.online === false ? 0.55 : 1,
          }}
        >
          <Typography fontWeight={700} sx={{ minWidth: "26px" }}>
            {index === 0 ? "🥇" : index === 1 ? "🥈" : index === 2 ? "🥉" : `#${index + 1}`}
          </Typography>
          <Typography
            sx={{ flex: 1, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}
            fontWeight={row.pid === myPid ? 700 : 500}
            fontSize="0.9rem"
          >
            {row.name}
          </Typography>
          <Typography fontSize="0.8rem">⭐{row.stars}</Typography>
          <Typography fontWeight={700} fontSize="0.9rem">{row.score}</Typography>
        </Box>
      ))}
    </Box>
  );
};

export default Leaderboard;
